// Müşteri kurulumu için küratörlü listeler (piyasa iş kolları + çalışma modları).
// Sektör = iş kolu (ne satıyor). Çalışma modu = nasıl çalışıyor (kanal). İkisi de çok seçimli.
export const SECTORS = [
  { code: "market", name: "Market & Bakkal" },
  { code: "restoran", name: "Restoran & Kafe" },
  { code: "giyim", name: "Giyim & Tekstil" },
  { code: "elektronik", name: "Elektronik & Teknoloji" },
  { code: "yapi_market", name: "Yapı Market & Nalbur" },
  { code: "eczane", name: "Eczane & Medikal" },
  { code: "kozmetik", name: "Kozmetik & Kişisel Bakım" },
  { code: "kirtasiye", name: "Kırtasiye & Ofis" },
  { code: "oto_parca", name: "Oto Yedek Parça" },
  { code: "petshop", name: "Pet Shop & Veteriner" },
  { code: "mobilya", name: "Mobilya & Dekorasyon" },
  { code: "kuyum", name: "Kuyum & Saat" },
  { code: "uretim", name: "Üretim & İmalat" },
  { code: "otel", name: "Otel & Konaklama" },
  { code: "hizmet", name: "Hizmet & Teknik Servis" },
];

export const MODES = [
  { code: "perakende", name: "Perakende / Market (POS)", desc: "Mağazada kasadan satış" },
  { code: "depo", name: "Depo / Stok", desc: "Stok, sayım, transfer, mal kabul" },
  { code: "toptan", name: "Toptan / Dağıtım", desc: "Toptan satış, cari, sevkiyat" },
  { code: "eticaret", name: "E-Ticaret / Online", desc: "Online kanal & pazar yerleri" },
];

export const sectorName = (code) => (SECTORS.find((s) => s.code === code) || {}).name || code;
export const modeName = (code) => (MODES.find((m) => m.code === code) || {}).name || code;
export const slugTr = (s) =>
  (s || "").toLowerCase()
    .replace(/ç/g, "c").replace(/ğ/g, "g").replace(/ı/g, "i")
    .replace(/ö/g, "o").replace(/ş/g, "s").replace(/ü/g, "u")
    .replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
